import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactList from "./ContactList";
import type ContactListsContact from "./ContactListsContact";
import type Organisation from "./Organisation";
import type Outlet from "./Outlet";
import type PrivateInfluencerAddress from "./PrivateInfluencerAddress";
import type PrivateOutlet from "./PrivateOutlet";
import type { Email, Phone, Social } from "./types";

@Model()
class PrivateInfluencer extends ApplicationRecord {
  static jsonapiType = "private_influencers";

  @Attr({ persist: false }) archivedAt: string;

  @HasMany() contactLists: ContactList[];

  @HasMany() contactListsContacts: ContactListsContact[];

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) documentId: string;

  @Attr() email: string;

  @Attr({ persist: false }) emails: Email[];

  @Attr() firstName: string;

  @Attr() invalidEmail: boolean;

  @Attr() jobTitle: string;

  @Attr() language: string;

  @Attr() lastName: string;

  @Attr() linkedin: string;

  @Attr() name: string;

  @Attr() note: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() phone: string;

  @Attr({ persist: false }) phones: Phone[];

  @HasMany({ name: "privateInfluencerAddresses" })
  privateInfluencerAddresses: PrivateInfluencerAddress[];

  @HasMany() privateInfluencerPublicOutlets: Outlet[];

  @HasMany() privateOutlets: PrivateOutlet[];

  @Attr() salutation: string;

  @Attr({ persist: false }) socials: Social[];

  @Attr({ persist: false }) success: boolean;

  @Attr() twitter: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default PrivateInfluencer;
